function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31919",
  "data-name": "Path 31919",
  d: "M306.492,113.56a33.143,33.143,0,1,0,0,.005Z",
  transform: "translate(-240.18 -80.42)",
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_9158",
  "data-name": "Rectangle 9158",
  width: 3.444,
  height: 8.883,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "response_summary",
  "data-name": "response summary",
  transform: "translate(-933.2 -1683.037)"
}, /*#__PURE__*/React.createElement("g", {
  id: "no_user_found",
  "data-name": "no user found",
  transform: "translate(48.2 1359.037)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_19700",
  "data-name": "Group 19700",
  transform: "translate(885 324)"
}, /*#__PURE__*/React.createElement("g", {
  id: "no-user-found",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_19388",
  "data-name": "Group 19388",
  transform: "translate(31.175 34.438)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31891",
  "data-name": "Path 31891",
  d: "M306.492,113.56a33.143,33.143,0,1,0,0,.005Z",
  transform: "translate(-239.818 -80.42)",
  fill: "#f9fafb",
  stroke: "#bdc9d5",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_19387",
  "data-name": "Group 19387",
  transform: "translate(0 0.363)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31912",
  "data-name": "Path 31912",
  d: "M265.039,97.582a.162.162,0,1,1-.053-.12.161.161,0,0,1,.053.12Z",
  transform: "translate(-225.061 -69.938)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31918",
  "data-name": "Path 31918",
  d: "M256.5,97.582a.146.146,0,0,0,.162.162.162.162,0,1,0,0-.323.146.146,0,0,0-.162.162Z",
  transform: "translate(-230.118 -69.938)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_9556",
  "data-name": "Rectangle 9556",
  width: 21.108,
  height: 3.52,
  transform: "translate(76.534 18.726)",
  fill: "rgba(189,201,213,0.25)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_9557",
  "data-name": "Rectangle 9557",
  width: 15.039,
  height: 3.52,
  transform: "translate(76.534 27.447)",
  fill: "rgba(189,201,213,0.25)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_19389",
  "data-name": "Group 19389"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18801",
  "data-name": "Group 18801",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18601",
  "data-name": "Group 18601",
  transform: "translate(91.152 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18598",
  "data-name": "Group 18598",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18578",
  "data-name": "Group 18578",
  opacity: 0.6
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18577",
  "data-name": "Group 18577"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18576",
  "data-name": "Group 18576",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31272",
  "data-name": "Path 31272",
  d: "M1315.184,414.119c.3,2.451-.191,4.526-1.094,4.636s-1.877-1.787-2.176-4.238.191-4.526,1.093-4.636,1.877,1.787,2.176,4.238",
  transform: "translate(-1311.828 -409.877)",
  fill: "#fff"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_18602",
  "data-name": "Group 18602",
  transform: "translate(0 14.166)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_2207",
  "data-name": "Line 2207",
  x2: 14.073,
  transform: "translate(5.733 88.678)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2208",
  "data-name": "Line 2208",
  x2: 26.582,
  transform: "translate(0 98.06)",
  fill: "none",
  stroke: "#cad4dd",
  strokeWidth: 2,
  strokeDasharray: 5,
  opacity: 0.58
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_18017",
  "data-name": "Group 18017",
  transform: "translate(123.41 92.065)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518",
  "data-name": "Rectangle 7518",
  width: 2.085,
  height: 12.509,
  rx: 1.042,
  transform: "translate(5.212)",
  fill: "#d8dade"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519",
  "data-name": "Rectangle 7519",
  width: 2.085,
  height: 12.509,
  rx: 1.042,
  transform: "translate(12.509 5.212) rotate(90)",
  fill: "#d8dade"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_18018",
  "data-name": "Group 18018",
  transform: "translate(12.77 56.776)",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518-2",
  "data-name": "Rectangle 7518",
  width: 2.085,
  height: 12.509,
  rx: 1.042,
  transform: "translate(5.212)",
  fill: "#cad4dd"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519-2",
  "data-name": "Rectangle 7519",
  width: 2.085,
  height: 12.509,
  rx: 1.042,
  transform: "translate(12.509 5.212) rotate(90)",
  fill: "#cad4dd"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2885",
  "data-name": "Ellipse 2885",
  transform: "translate(39.599 7)",
  fill: "#fff",
  stroke: "#d8dade",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 4.691,
  cy: 4.691,
  r: 4.691,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.691,
  cy: 4.691,
  r: 3.691,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "mail-reply",
  d: "M13.969,12a27.941,27.941,0,0,1,9.047,2.859,20.917,20.917,0,0,1,6.515,5.2,29.455,29.455,0,0,1,4.078,6.516A35.875,35.875,0,0,1,36,34.031Q28.687,23.812,13.969,23.812v8.156L0,18,13.969,4.031Z",
  transform: "translate(43.8 31.766)",
  fill: "#bdc9d5"
}))))), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3147",
  "data-name": "Ellipse 3147",
  cx: 18.5,
  cy: 18.5,
  r: 18.5,
  transform: "translate(71.8 74.964)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_18837",
  "data-name": "Group 18837",
  transform: "translate(76.866 79.399)"
}, /*#__PURE__*/React.createElement("g", {
  id: "search",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31327",
  "data-name": "Path 31327",
  d: "M23.453,23.453a2.106,2.106,0,0,1,2.981,0l8.109,8.109a2.107,2.107,0,1,1-2.978,2.981l-8.109-8.109a2.106,2.106,0,0,1,0-2.981Z",
  transform: "translate(-1.457 -1.457)",
  fill: "#f3994e",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31328",
  "data-name": "Path 31328",
  d: "M13.692,25.277A11.585,11.585,0,1,0,2.106,13.692,11.585,11.585,0,0,0,13.692,25.277ZM27.384,13.692A13.692,13.692,0,1,1,13.692,0,13.692,13.692,0,0,1,27.384,13.692Z",
  fill: "#cad4dd",
  fillRule: "evenodd"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "emoji-smile",
  transform: "translate(1032.8 1707.879)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_32070",
  "data-name": "Path 32070",
  d: "M9.6,18A8.4,8.4,0,1,0,1.2,9.6,8.4,8.4,0,0,0,9.6,18Zm0,1.2A9.6,9.6,0,1,0,0,9.6,9.6,9.6,0,0,0,9.6,19.2Z",
  fill: "#d8dade",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32071",
  "data-name": "Path 32071",
  d: "M9.378,21.455a.6.6,0,0,1,.82.22,4.2,4.2,0,0,0,7.277,0,.6.6,0,1,1,1.039.6,5.4,5.4,0,0,1-9.355,0,.6.6,0,0,1,.22-.82Z",
  transform: "translate(-4.236 -9.975)",
  fill: "#d8dade",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32072",
  "data-name": "Path 32072",
  d: "M13.65,13.05c0,.994-.538,1.8-1.2,1.8s-1.2-.806-1.2-1.8.538-1.8,1.2-1.8S13.65,12.056,13.65,13.05Zm4.8,0c0,.994-.538,1.8-1.2,1.8s-1.2-.806-1.2-1.8.538-1.8,1.2-1.8S18.45,12.056,18.45,13.05Z",
  transform: "translate(-5.25 -5.25)",
  fill: "#d8dade"
})), /*#__PURE__*/React.createElement("path", {
  id: "star",
  d: "M14.666,6.709a1.148,1.148,0,0,0-.911-.782l-3.283-.533L8.949,2.436a1.153,1.153,0,0,0-2.05,0L5.377,5.394l-3.283.533a1.153,1.153,0,0,0-.633,1.95L3.8,10.239,3.3,13.526a1.152,1.152,0,0,0,1.659,1.205l2.97-1.5,2.97,1.5a1.153,1.153,0,0,0,1.659-1.205l-.507-3.288,2.343-2.362a1.148,1.148,0,0,0,.278-1.168Zm-.921.53L11.08,9.926l.577,3.74a.246.246,0,0,1-.355.257l-3.378-1.7-3.378,1.7a.246.246,0,0,1-.355-.257l.577-3.74L2.1,7.239a.247.247,0,0,1,.135-.417l3.735-.607L7.705,2.851a.246.246,0,0,1,.438,0L9.874,6.215l3.735.607a.247.247,0,0,1,.135.417Z",
  transform: "translate(942.999 1715.667)",
  fill: "#d8dade"
}));

function SvgResponseSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.919,
    height: 118.74,
    viewBox: "0 0 135.919 118.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponseSummary);
export default __webpack_public_path__ + "static/media/response-summary.b6f82b4e.svg";
export { ForwardRef as ReactComponent };